import { Button, Col, DatePicker, Form, Input, InputNumber, Modal, Row, Select, Switch, Upload, UploadProps } from "antd";
import { User } from "../../../model/root/User";
import { PutUsuariIdPerfil } from "../../../dao/root/PutUsuariIdPerfil";
import { BiCheck, BiX } from "react-icons/bi";
import Colors from "../../../styles/Colors";
import toast from "react-hot-toast";
import { useContext, useState } from "react";
import { AuthContext } from "../../../config/AuthContext";
import { UploadOutlined } from "@ant-design/icons";
import Password from "antd/es/input/Password";

interface IngredientModalProps {
    element: User;
    visible: boolean;
    page: string;
    onClose: () => void;
}

const ProfileModal: React.FC<IngredientModalProps> = ({element, visible, page, onClose}) => {
    const { isLoggedIn, userId } = useContext(AuthContext);
    const [form] = Form.useForm();
    const [usuari, setUsuari] = useState<any>({});

    async function handleSubmit() {
        const id = await form.getFieldValue('id');
        await PutUsuariIdPerfil(id, page, form);
        await onClose();
    };

    async function handleCancel() {

        await onClose();
    };
    
    const apiUrl = process.env.REACT_APP_API_URL;
    const props: UploadProps = {
        name: 'files',
        method: 'POST',
        multiple: false,
        action: `${apiUrl}:8071/usuaris/${userId}/document/monitor`,
        headers: {
            'pantalla': `${page}`
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                toast.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === 'error') {
                toast.error(`${info.file.name} file upload failed.`);
            }
        },
    };
  const props2: UploadProps = {
        name: 'files',
        method: 'POST',
        multiple: false,
        action: `${apiUrl}:8071/usuaris/${userId}/document/cv`,
        headers: {
            'pantalla': `${page}`
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                toast.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === 'error') {
                toast.error(`${info.file.name} file upload failed.`);
            }
        },
    };
  const props3: UploadProps = {
        name: 'files',
        method: 'POST',
        multiple: false,
        action: `${apiUrl}:8071/usuaris/${userId}/document/sexuals`,
        headers: {
            'pantalla': `${page}`
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                toast.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === 'error') {
                toast.error(`${info.file.name} file upload failed.`);
            }
        },
    };

    return(
        <Modal
            title="Editar Usuari"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={1000}
        >
            <Form form={form} initialValues={element}>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item label="id" name="id">
                            <Input type="text" disabled={true}/>
                        </Form.Item>
                        <Form.Item name="nombre" label="Nom"
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item name="cognoms" label="Cognoms"
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item name="dni" label="DNI" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name="domicili" label="Domicili Actualitzat">
                            <Input />
                        </Form.Item>
                        <Form.Item name="seguretatSocial" label="Número Afiliació Seguretat Social" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name="telefon" label="Tel. Contacte" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name="telefon2" label="Tel. Contacte Alternatiu">
                            <Input />
                        </Form.Item>
                        <Form.Item name="correu" label="Correu Electrònic" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name="iban" label="Número Compte Bancari">
                            <Input />
                        </Form.Item>
                        <Form.Item name="naixFills" label="Any Naixement Fills">
                            <DatePicker
                                multiple
                                picker={"year"}
                                //onChange={onChange}
                                maxTagCount="responsive"
                                //defaultValue={usuari?.naixFills}
                                size="small"
                            />
                        </Form.Item>
                        <Form.Item name="grauDiscapacitatDetall" label="Tens reconegut algun grau de discapacitat? En cas afirmatiu, indica el grau, sinó deixa en blanc">
                            <InputNumber />
                        </Form.Item>
                        <Form.Item name="convivencia" label="Convius amb algú major de 26 anys que depengui de tu?">
                            <Switch />
                        </Form.Item>
                        <Form.Item name="disciplines" label="Tens coneixement en alguna disciplina?">
                                <Select
                                    mode="multiple"
                                    allowClear
                                    style={{ width: '100%' }}
                                    placeholder="Marca totes les que vulguis"
                                    //onChange={handleChange}
                                    options={[
                                        { label: 'Bàsquet', value: 'Bàsquet' },
                                        { label: 'Futbol', value: 'Futbol' },
                                        { label: 'Escacs', value: 'Escacs' },
                                        { label: 'Patinatge', value: 'Patinatge' },
                                        { label: 'Karate', value: 'Karate' },
                                        { label: 'Judo', value: 'Judo' },
                                        { label: 'Tennis Taula', value: 'Tennis Taula' },
                                        { label: 'Dansa', value: 'Dansa' },
                                        { label: 'Hip-Hop', value: 'Hip-Hop' },
                                        { label: 'Gimnàstica Rítmica', value: 'Gimnàstica Rítmica' },
                                        { label: 'Aeròbic', value: 'Aeròbic' },
                                        { label: 'Ioga', value: 'Ioga' },
                                        { label: 'Coral', value: 'Coral' },
                                        { label: 'Teatre', value: 'Teatre' },
                                        { label: 'Plàstica', value: 'Plàstica' },
                                        { label: 'Cuina Freda o Calenta', value: 'Cuina Freda o Calenta' },
                                        { label: 'Robòtica', value: 'Robòtica' },
                                        { label: 'Música', value: 'Música' },
                                        { label: 'Anglès', value: 'Anglès' }
                                    ]}
                                />
                        </Form.Item>
                        <Form.Item name="carnetMonitor" label="Adjuntar carnet Monitor">
                            <b>{usuari.monitor ? usuari.monitor : ""}{" "}</b>
                            <Upload {...props}>
                                <Button  icon={<UploadOutlined />}>{usuari.monitor ? "Tornar a Carregar fitxer" : "Carregar fitxer"}</Button>
                            </Upload>
                        </Form.Item>
                        <Form.Item name="cv" label="Adjuntar CV">
                            <b>{usuari.cv ? usuari.cv : ""}{" "}</b>
                            <Upload {...props2}>
                                <Button  icon={<UploadOutlined />}>{usuari.cv ? "Tornar a Carregar fitxer" : "Carregar fitxer"}</Button>
                            </Upload>
                        </Form.Item>
                        <Form.Item name="certificatDelictes" label="Adjuntar Certificat Negatiu Delictes Sexuals">
                            <b>{usuari.sexuals ? usuari.sexuals : ""}{" "}</b>
                            <Upload {...props3}>
                                <Button  icon={<UploadOutlined />}>{usuari.sexuals ? "Tornar a Carregar fitxer" : "Carregar fitxer"}</Button>
                            </Upload>
                        </Form.Item>
                        <Form.Item name="nuevaPassword" label="Nova contraseña">
                            <Password />
                        </Form.Item>
                        <Form.Item name="repetirNovaPassword" label="Repetir Nova contraseña">
                            <Password />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default ProfileModal;
